import BithidePaymentMain from './BithidePaymentMain';
export default BithidePaymentMain;
